var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: _vm.title,
      loading: _vm.loading,
      "delete-dialog-title": _vm.$t("DeleteTicket"),
      "delete-dialog-content": _vm.deleteMessage,
      "delete-button": _vm.userHasPermissionTo("destroy"),
      "edit-button": _vm.userHasPermissionTo("update"),
      "permission-name": _vm.permissionName
    },
    on: { editItem: _vm.editItem, deleteItem: _vm.deleteTicket },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return _c("view-page-data-field", {
              key: field.template,
              attrs: { icon: field.icon, label: field.label, data: field.data }
            })
          })
        },
        proxy: true
      },
      {
        key: "headerRightSide",
        fn: function() {
          return [
            _c(
              "div",
              [
                _c("management-tabs-and-search", {
                  attrs: { tabs: _vm.tabs, "open-tab": _vm.openTab },
                  on: {
                    "update-open-tab": function($event) {
                      _vm.openTab = $event
                    }
                  }
                }),
                _vm._v(" "),
                _vm.openTab === "comments"
                  ? _c("management-add-button", {
                      attrs: {
                        label: _vm.$t("AddComment"),
                        disabled: !_vm.userHasManagementPermission(
                          "third_party_apis_youtrack_comments",
                          "store"
                        ),
                        "list-missing-permissions": []
                      },
                      on: { buttonClick: _vm.createComment }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.openTab === "attachments"
                  ? _c("management-add-button", {
                      attrs: {
                        label: _vm.$t("AddAttachment"),
                        disabled: false,
                        "list-missing-permissions": []
                      },
                      on: { buttonClick: _vm.openAttachmentForm }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "rightSide",
        fn: function() {
          return [
            _vm.ticket
              ? _c(
                  "v-tabs-items",
                  {
                    key: _vm.ticket.comments.length,
                    attrs: { value: _vm.openTab }
                  },
                  [
                    _c(
                      "v-tab-item",
                      {
                        staticClass: "elevation-2",
                        attrs: { value: "description" }
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ticket.description,
                              expression: "ticket.description"
                            }
                          ],
                          staticClass: "input-field",
                          staticStyle: { height: "379px" },
                          attrs: { id: "description", readonly: "" },
                          domProps: { value: _vm.ticket.description },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.ticket,
                                "description",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "comments" } },
                      [
                        _c("ticket-comments-table", {
                          attrs: { ticketId: _vm.ticket.id },
                          on: { "open-comment": _vm.openComment }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "attachments" } },
                      [
                        _c("attachments-table", {
                          attrs: { attachments: _vm.ticket.attachments },
                          on: {
                            "open-attachment": function($event) {
                              return _vm.openAttachment($event)
                            },
                            "reload-ticket": _vm.getTicket
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("attachment-form", {
              attrs: { open: _vm.attachmentForm.isOpen },
              on: {
                "add-attachment": function($event) {
                  return _vm.saveAttachment($event)
                },
                close: _vm.closeAttachmentForm
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17817b18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17817b18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/TicketsDetails.vue
// module id = null
// module chunks = 